import React from 'react'
import PropTypes from 'prop-types'
import Link from 'redux-first-router-link'
import connect from 'react-redux/es/connect/connect'
import DefaultFrame from '../components/frame/DefaultFrame'
import SquadMonitor from '../components/entity/SquadMonitor'
import { goToSquad, goToBattle } from '../redux/actions/routing/route.actions'
import getSquadWithEquipment from '../redux/selectors/getSquadWithEquipment'
import getStagesFromProgression from '../redux/selectors/getStagesFromProgression'
import BackLink from '../components/ui/navigation/BackLink'

const Adventure = ({ squadUnits, stages }) => {
    const stageSelection = !squadUnits.length
        ? (
            <div className="no__units">
                Please select at least one unit for your current squad!
            </div>
        )
        : (
            stages.map((stage) => {
                const {
                    ID, title, status, location,
                } = stage
                const stageCount = location.length
                const stageTitle = title || ID
                const StageBadge = (status === 'failed') ? '' : (
                    <div className={`stage__badge stage__badge--${status}`}>
                        {status}
                    </div>
                )
                return !status ? '' : (
                    <Link
                        key={ID}
                        className={`stage__box stage__box--${status}`}
                        to={goToBattle(ID)}
                    >
                        {StageBadge}
                        <div className="stage__box--title">
                            {stageTitle}
                        </div>
                        <div className="stage__box--stages">
                            {`Stages: ${stageCount}`}
                        </div>
                    </Link>
                )
            })
        )
    return (
        <DefaultFrame>
            <div className="scene--base scene__adventure">
                <div className="scene--title">
                    <BackLink>
                        <button className="backLink--title" type="button">Back</button>
                    </BackLink>
                    <h1>Adventure</h1>
                </div>
                <SquadMonitor
                    squadUnits={squadUnits}
                    handleEdit={{ enabled: false }}
                    handleDelete={{ enabled: false }}
                >
                    <Link className="buttonLink--wrapper" to={goToSquad()}>
                        <button type="button">Edit Squad</button>
                    </Link>
                </SquadMonitor>
                <h2>
                    Select a stage:
                </h2>
                <div className="adventure__stage--list">
                    {stageSelection}
                </div>
            </div>
        </DefaultFrame>
    )
}

Adventure.propTypes = {
    squadUnits: PropTypes.array.isRequired,
    stages: PropTypes.array.isRequired,
}

const mapStateToProps = state => ({
    squadUnits: getSquadWithEquipment(state),
    stages: getStagesFromProgression(state),
})

export default connect(
    mapStateToProps,
)(Adventure)
